import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgbModal, NgbModalConfig, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxPaginationModule } from 'ngx-pagination';
import { ToastrService } from 'ngx-toastr';
import { CarReservationService } from '../../../../core/services/car-reservation.service';
import { SampleSearchPipe } from '../../../../core/pipes/sample-search.pipe';
import { AppActionCheck } from '../../../../core/utils/app-action-check';
import { AppErrorShow } from '../../../../core/utils/app-error-show';
import { AppSweetAlert } from '../../../../core/utils/app-sweet-alert';
import { LocalStorageService } from '../../../../core/utils/local-stoarge-service';
import { LoadingComponent } from '../../../shared/loading/loading.component';
import { StatusComponent } from '../../component/status/status.component';

@Component({
  selector: 'app-car-reservation',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    NgbModule,
    NgxPaginationModule,
    LoadingComponent,
    SampleSearchPipe,
    StatusComponent
  ],
  templateUrl: './car-reservation.component.html',
  styleUrl: './car-reservation.component.css'
})
export class CarReservationComponent {
  buttonsPermission: any | undefined;
  data: any[] = [];
  selected_data: any;
  loading = false;
  loading2 = false;
  tag = "Réservations véhicules";
  search_text = "";
  statusFilter = "";
  user: any;
  pg = {
    pageSize: 10,
    p: 0,
    total: 0
  }

  constructor(
    private carReservationService: CarReservationService,
    private toastrService: ToastrService,
    config: NgbModalConfig,
    private lsService: LocalStorageService,
    private modalService: NgbModal) {
    config.backdrop = 'static';
    config.keyboard = false;
  }

  ngOnInit(): void {
    this.init()
    this.getActions()
  }

  init() {
    this.getAll()
  }

  get filteredData() {
    if (!this.statusFilter) return this.data;
    return this.data.filter(d => d.status === this.statusFilter);
  }

  onFilterChange() {
    this.pg.p = 0
  }

  getAll() {
    this.loading2 = true
    this.carReservationService.getAll().subscribe((res: any) => {
      this.data = res.data
      this.pg.pageSize = 10
      this.pg.p = 0
      this.pg.total = res.data.length
      this.modalService.dismissAll()
      this.loading2 = false
    },
      (err: any) => {
        this.loading2 = false
        AppErrorShow.showError("Gestion des réservations", err)
      })
  }

  changeStatus(status: any) {
    if (!this.verifyIfElementChecked()) return;
    this.loading = true
    this.carReservationService.changeStatus(this.selected_data.id, status).subscribe((res: any) => {
      this.toastrService.success(res.message)
      this.loading = false
      this.getAll()
    },
      (err: any) => {
        this.loading = false
        AppErrorShow.showError("Gestion des réservations", err)
      })
  }

  checked(el?: any) {
    this.selected_data = el;
  }

  verifyIfElementChecked() {
    if (this.selected_data == null) {
      this.toastrService.warning("Aucun élément selectionné");
      return false;
    }
    return true;
  }

  show(content: any) {
    if (!this.verifyIfElementChecked()) return;
    this.modalService.open(content, { size: 'lg' });
  }

  dismiss() {
    this.modalService.dismissAll()
  }

  getActions() {
    this.buttonsPermission = {
      show: AppActionCheck.check(this.tag, 'Consulter'),
      status: true
    };
  }

  getPage(event: any) {
    this.pg.p = event
  }
}
